import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Button } from "aible";

import * as runReducer from "containers/Run/reducer";
import * as viewReducer from "containers/View/reducer";
import * as createReducer from "containers/CreateWizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as globalReducer from "containers/App/reducer";
import * as projectReducer from "containers/Project/reducer";

import RunItem from "containers/View/Item/RunItem";

import SubView from "components/View/SubView";

import RunTile from "components/Tiles/RunTile";
import EmptyTile from "components/Tiles/EmptyTile";

import { isEnabled } from "utils/featureFlags";

class RunViewContainer extends React.Component {
  handleClick(data) {
    const { history } = this.props;

    const isAdvanced = isEnabled("aible-advanced");

    if (isAdvanced) {
      return history.push("project/" + data.id);
    }
    return history.push("create/" + data.id);
  }

  renderFirstTile() {
    const { updateStep, updateDatasetId, history, hideFirstTile } = this.props;

    if (hideFirstTile) {
      return <EmptyTile />;
    }

    return <React.Fragment>{<RunTile isCreate />}</React.Fragment>;
  }

  renderFirstRow() {
    const { updateStep, history } = this.props;

    return (
      <Button type="secondary" onClick={() => {}}>
        {"Models"}
      </Button>
    );
  }

  getHeaders() {
    return ["Run", "Creation", "Run Type", "Outcome Type", "Status", "Best Model", "Best Result", "Created By"];
  }

  render() {
    const { isFrontierView, isTile, isJobsLoading, data, projectId, updateDrilldownValue, isInfinite } = this.props;

    return (
      <SubView
        {...this.props}
        label="Models"
        headers={this.getHeaders()}
        firstTile={this.renderFirstTile()}
        firstRow={this.renderFirstRow()}
        length={data.length}
        isLoading={isJobsLoading}
        isInfinite={isInfinite === undefined ? true : isInfinite}
        renderTile={(columnIndex, style) =>
          data && data.length > columnIndex ? (
            <RunItem
              id={data[columnIndex].id}
              key={columnIndex}
              style={style}
              isFrontier={isFrontierView}
              onClick={projectId ? (runId) => updateDrilldownValue(runId) : undefined}
              noDelete={Boolean(projectId)}
            />
          ) : undefined
        }
        childrenLength={data.length}
      ></SubView>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchNext: () => dispatch(runReducer.fetchNextRuns()),
  fetchAll: () => dispatch(runReducer.fetchNextRuns(true)),

  updateDatasetId: (datasetId) => dispatch(setupReducer.updateDatasetId("new", datasetId)),

  updateStep: (runId) => dispatch(createReducer.updateStep(runId)),
  updateDrilldownValue: (runId) => {
    if (ownProps.projectId) {
      ownProps.projectUpdateView && ownProps.projectUpdateView();
      const state = dispatch((dispatch, getState) => getState());
      const segment = projectReducer.getSegmentByRunId(state, ownProps.projectId, runId);
      const value = segment.conditions && segment.conditions.length > 0 ? segment.conditions[0].value : "Overall";
      return dispatch(projectReducer.updateDrilldownValue(ownProps.projectId, runId, value));
    }
  }
});

const mapStateToProps = (state, ownProps) => {
  let retData, onClick;
  let retState = {};
  if (ownProps.projectId) {
    retData = projectReducer.getProjectRuns(state, ownProps.projectId);
  } else {
    retData = viewReducer.getRuns(state);
  }
  return {
    data: retData,
    isTile: viewReducer.getIsTile(state),
    type: ownProps.type ? ownProps.type : viewReducer.getType(state),

    isJobsLoading: globalReducer.getIsJobsLoading(state),
    hoverItem: globalReducer.getHoverItem(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RunViewContainer);
